
export const user_navigation = [
    // all users
    // {name: 'Account', path: '/settings/profile'},
    {name: 'Settings', path: '/settings/change-password'},
    // {name: 'Support', path: '/support/'}
]
